import { formatPlatformName, PLATFORMS } from "../../constants/constants";

export const useConnectionStatus = ({ assistant, isInstallPage }) => {
  const platformName = assistant?.platform?.type;
  const supportedPlatforms = Object.values(PLATFORMS);

  if (!supportedPlatforms.includes(platformName)) {
    return {
      showButton: false,
      buttonText: "",
      isDisconnectAction: false,
    };
  }

  const formatted = formatPlatformName(platformName);
  const buttonText = !isInstallPage
    ? `Disconnect ${formatted}`
    : `Connect ${formatted}`;

  return {
    showButton: true,
    buttonText,
    isDisconnectAction: buttonText.includes("Disconnect"),
  };
};
